import { BrandRepository } from '../../domain/repositories/brand.repository';
import { BrandEntity } from '../../domain/entities/brand.entity';

export class GetBrandsUseCase {
  constructor(private readonly brandRepository: BrandRepository) {}

  async execute(options?: { activeOnly?: boolean; search?: string }): Promise<BrandEntity[]> {
    return this.brandRepository.getBrands(options);
  }
}
